import * as setup from 'setup';

export function capitalize(text?: string | null) {
    return text ? (text.charAt(0).toUpperCase() + text.substring(1)) : '';
}

export function getAntUnlock(type: AntType) {
    return `ant${capitalize(type)}` as GameUnlock;
}

export function getEntityCategoryGroup<T = EntityCategoryGroup>(category: EntityCategory) {
    return `${category}s` as T;
}

export function getEntityTypeGroup<T = EntityTypeGroup>(type: EntityType) {
    return `${type}s` as T;
}

export function parseHtml(text: string) {
    // Replace \n with <br/>
    // Replace _..._ with italic
    // Replace *...* with bold
    let parsed = text.replace(/\n/g, '<br/>')
        .replace(/\_(.*?)\_/g, '<i>$1</i>')
        .replace(/\*(.*?)\*/g, '<b>$1</b>');

    // Replace {...} with value from setup
    parsed.match(/{(.*?)}/g)?.forEach(match => {
        const keys = match.substring(1, match.length - 1).split('.');
        const value = keys.reduce((prevValue, key) => prevValue[key], setup as any);
        parsed = parsed.replaceAll(match, value);
    });

    return {
        __html: parsed,
    };
}